import {
  convertThemeV2ToCSS,
  fetchTenantConfigV2,
  type TenantResponse,
  type ThemeConfigV2,
} from "@highereducation/dynamic-experience/utils";
import { mapTenantThemeToLpPrimaryColorsCss } from "./mapTenantThemeToLpPrimaryColorsCss";

/**
 * One tenant-config fetch → DE scoped CSS + LP :root brand vars (--primary-1…4).
 * Fail-soft: returns "" when the theme cannot be fetched.
 */
export async function getTenantThemeStylesheet(
  tenantConfigId?: string | null,
  scoped: boolean = true,
): Promise<string> {
  if (!tenantConfigId) {
    return "";
  }

  if (!process.env.TENANT_CONFIG_API_URL) {
    console.warn("TENANT_CONFIG_API_URL is not set. Tenant theme stylesheet cannot be fetched.");
    return "";
  }

  return fetchTenantConfigV2(process.env.TENANT_CONFIG_API_URL, tenantConfigId, { types: ["theme"] })
    .then((res: TenantResponse) => {
      const theme = (res?.configs?.theme ?? {}) as ThemeConfigV2;
      return [convertThemeV2ToCSS(theme, scoped), mapTenantThemeToLpPrimaryColorsCss(theme)].filter(Boolean).join("\n");
    })
    .catch(() => "");
}
